import React, { useState } from 'react';
import { ListGroup, Button, Row, Col, Image, Offcanvas, Form } from 'react-bootstrap';
import { Trash3Fill, Whatsapp } from 'react-bootstrap-icons';
import { useCarrito } from './CarritoContext';
import { useParams } from 'react-router-dom';
import { API } from '../../../../api/URL_API';
import axios from 'axios';
import { trackRemoveFromCart, trackInitiateCheckout } from '../../../../utils/metaPixel';
import { getTrackingData } from '../../../../utils/trackingData';

function CarUni({ show, handleClose }) {
    const {
        carrito,
        removeFromCarrito,
        increaseQuantity,
        decreaseQuantity,
        clearCarrito,
        calculateShippingCost,
        configEnvio,
        calculateDiscount,
        calculateTotalWithDiscount,
        configDescuento = {}
    } = useCarrito();

    const { idSucursal } = useParams();
    const [isSending, setIsSending] = useState(false);
    const [nombreCliente, setNombreCliente] = useState('');
    const [telefonoCliente, setTelefonoCliente] = useState('');
    const [validated, setValidated] = useState(false); // Estado para la validación del formulario

    const isEnvioDisabled = configEnvio?.tipoConfig === 'desable';
    let envioCosto = calculateShippingCost();
    if (isEnvioDisabled) {
        envioCosto = 0;
    }

    // Obtenemos el descuento y lo mostramos en consola
    const descuento = calculateDiscount();

    // Cálculo del precio total (sin descuento aplicado)
    const totalPrecio = carrito.reduce((total, product) => {
        const price = configDescuento?.tipoConfig === 'desable'
            ? parseFloat(product.precioU.toString().replace('$', '').replace(',', ''))
            : parseFloat(
                // Si el descuento es distinto de null (aunque sea 0) usamos precioU,
                // de lo contrario (si es null) usamos precioM.
                descuento !== null
                    ? (() => {
                        return product.precioU.toString().replace('$', '').replace(',', '');
                    })()
                    : (() => {
                        return product.precioM.toString().replace('$', '').replace(',', '');
                    })()
            );
        const quantity = Number(product.quantity) || 1;
        return total + (price * quantity);
    }, 0);

    const porcentajeDescuento = descuento; // Se usa para mostrar el descuento
    const totalConDescuento = calculateTotalWithDiscount();

    // Calcular la cantidad total de productos
    const totalProductosQuantity = carrito.reduce(
        (acc, product) => acc + (Number(product.quantity) || 1),
        0
    );

    const handleRemoveProduct = (product) => {
        trackRemoveFromCart(product);
        removeFromCarrito(product.idProducto, product.selectedColor, product.selectedSize);
    };

    const handleIncreaseQuantity = (idProducto, selectedColor, selectedSize) => {
        increaseQuantity(idProducto, selectedColor, selectedSize);
    };

    const handleDecreaseQuantity = (idProducto, selectedColor, selectedSize) => {
        decreaseQuantity(idProducto, selectedColor, selectedSize);
    };

    const handleClearCarrito = () => {
        clearCarrito();
    };

    const formatPhoneNumber = (number) => {
        const cleanedNumber = number.replace(/\D/g, '');
        return `+57${cleanedNumber}`;
    };

    // Función para formatear montos (con separador de miles)
    const formatCurrency = (amount) => {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    const handleSendPedido = async (e) => {
        if (!nombreCliente.trim() || !telefonoCliente.trim()) {
            setValidated(true);
            return;
        }

        setIsSending(true);

        // Evento Meta Pixel InitiateCheckout
        trackInitiateCheckout(totalConDescuento + envioCosto, totalProductosQuantity);

        try {
            // Determinar el tipo de pedido según la configuración de precios
            const tipoPedido = configDescuento?.tipoConfig === 'desable' || descuento !== null
                ? 'unidad'
                : 'distribucion';
            const pedido = {
                idCliente: 36,
                idSucursal: idSucursal ? parseInt(idSucursal) : 1,
                tipo: tipoPedido,
                creacion: new Date().toISOString().split('T')[0],
                vence: new Date(new Date().setDate(new Date().getDate())).toISOString().split('T')[0],
                costoEnvio: envioCosto,
                totalProductos: totalConDescuento,
                totalPedido: totalConDescuento + envioCosto,
                pagado: 0,
                pendiente: totalConDescuento + envioCosto,
                estado: 'pendiente',
                descuento: descuento
            };

            const detallesPedido = carrito.map(product => {
                const price = configDescuento?.tipoConfig === 'desable'
                    ? parseFloat(product.precioU.toString().replace('$', '').replace(',', ''))
                    : parseFloat(
                        descuento !== null
                            ? product.precioU.toString().replace('$', '').replace(',', '')
                            : product.precioM.toString().replace('$', '').replace(',', '')
                    );
                const subtotal = price * (product.quantity || 1);
                //console.log("handleSendPedido -> Producto:", product.idProducto, "Precio usado:", price, "Subtotal:", subtotal);
                return {
                    idProductoTienda: product.idProducto,
                    idProducto: product.referencia,
                    cantidad: product.quantity || 1,
                    subtotal: subtotal,
                    totalPedido: subtotal,
                    idColor: product.selectedColor?.id,
                    idTalla: product.selectedSize?.id,
                };
            });

            // Capturar datos de seguimiento de Meta
            const metaTrackingData = getTrackingData();

            const payloadData = {
                pedido,
                detallesPedido,
                nombreCliente: nombreCliente.trim(),
                numeroCliente: telefonoCliente.trim(),
                metaTrackingData
            };

            //console.log('Datos enviados al servidor (incluyendo Meta Tracking):', payloadData);

            const response = await axios.post(`${API}/api/pedidos/carrito`, payloadData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            clearCarrito();

            const data = response.data;
            const numeroPedido = data.numeroPedido;

            let sucursalData;
            let numeroSucursal;
            try {
                const sucursalResponse = await axios.get(`${API}/api/pedidos/sucursal/${idSucursal}`);
                sucursalData = sucursalResponse.data;
                numeroSucursal = sucursalData.numSucursal;
            } catch (error) {
                // Si falla, intenta con idSucursal 1 por defecto
                try {
                    const sucursalResponseDefault = await axios.get(`${API}/api/pedidos/sucursal/1`);
                    sucursalData = sucursalResponseDefault.data;
                    numeroSucursal = sucursalData.numSucursal;
                } catch (error2) {
                    throw new Error('Número de sucursal no disponible');
                }
            }

            const formattedNumeroSucursal = formatPhoneNumber(numeroSucursal);
            const textoEnvio = isEnvioDisabled
                ? '+ Costo de Envío'
                : (envioCosto > 0
                    ? `$${formatCurrency(envioCosto)}`
                    : '¡GRATIS!');

            let productList = 'Detalle de productos:\n\n';

            carrito.forEach((product) => {
                const price = configDescuento?.tipoConfig === 'desable'
                    ? parseFloat(product.precioU.toString().replace('$', '').replace(',', ''))
                    : parseFloat(
                        descuento !== null
                            ? product.precioU.toString().replace('$', '').replace(',', '')
                            : product.precioM.toString().replace('$', '').replace(',', '')
                    );

                const quantity = product.quantity || 1;
                const subtotal = price * quantity;
                productList += `${product.nomProducto} | ${quantity} | $${formatCurrency(price)} | $${formatCurrency(subtotal)}\n`;
            });
            productList += `\nTotal productos: ${totalProductosQuantity} unidades\n`;
            productList += `Costo del Pedido: $${formatCurrency(totalConDescuento)}\n`;
            productList += `Costo envío: ${textoEnvio}\n`;
            productList += `Total a pagar: $${formatCurrency(totalConDescuento + envioCosto)}\n`;

            const mensajeWhatsApp =
                `Hola, soy *${nombreCliente.trim()}* (Tel: ${telefonoCliente.trim()}).\n` +
                `Acabas de realizar un pedido con el número: *${numeroPedido}*.\n\n` +
                productList +
                `\nVer pedido: https://aurora-bags.netlify.app/viewOrder/${numeroPedido}\n\n` +
                `Realizamos envios contra entrega a cuidades selccionadas. Para conocer el valor del envio y confirmar que realizamos envios contra entrega a tu ciudad, por favor responde a este mensaje con el nombre de tu ciudad y Departamento.`;

            const urlWhatsApp = `https://api.whatsapp.com/send?phone=${formattedNumeroSucursal}&text=${encodeURIComponent(mensajeWhatsApp)}`;

            window.location.href = urlWhatsApp;

        } catch (error) {
            console.error('Error al enviar el pedido:', error);
            alert(`Error al enviar el pedido: ${error.response?.data?.error || error.message}`);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <Offcanvas show={show} onHide={handleClose} placement='end' style={{ backgroundColor: '#f5efe8' }}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title className='color-primary fw-bold'>Tu Carrito</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <ListGroup variant="flush" style={{ borderRadius: '10px', marginBottom: '5px' }}>
                    {carrito.map((product) => (
                        <ListGroup.Item key={product.idProducto} style={{ boxShadow: '0 4px 8px rgba(43, 35, 94, 0.3), 0 6px 20px rgba(43, 35, 94, 0.3)', backgroundColor: '#f5efe8', border: '1px solid #e9ecef', borderRadius: '10px', marginBottom: '10px' }}>
                            <Row>
                                <Col xs={3} md={4}>
                                    <Image src={product.image} rounded fluid />
                                </Col>
                                <Col xs={4} md={6}>
                                    <span className='fw-bold color-primary text-uppercase'>{product.nomProducto}</span>
                                    {(() => {
                                        const precioU = parseFloat(product.precioU.toString().replace('$', '').replace(',', ''));
                                        const precioM = parseFloat(product.precioM.toString().replace('$', '').replace(',', ''));
                                        const isMayorista = configDescuento?.tipoConfig !== 'desable' && porcentajeDescuento === null;
                                        const priceWithDiscount = precioU * (1 - (porcentajeDescuento || 0) / 100);
                                        
                                        return (
                                            <div className="d-flex flex-column mt-1">
                                                {configDescuento?.tipoConfig === 'desable' ? (
                                                    <span className="fw-bold text-muted">
                                                        $ {formatCurrency(precioU)}
                                                    </span>
                                                ) : isMayorista ? (
                                                    <>
                                                        <div className='d-flex align-items-center mb-1'>
                                                            <span className='text-muted fw-bold text-uppercase' style={{ fontSize: '0.7em' }}>Mayorista:</span>
                                                            <span className="ms-1 badge" style={{ backgroundColor: '#e2e3e5', color: '#41464c', fontSize: '0.65em', border: '1px solid #d3d6d8' }}>Aplicado</span>
                                                        </div>
                                                        <span className='fw-bold' style={{ color: '#2E0205', fontSize: '1.05em' }}>
                                                            ${formatCurrency(precioM)}
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className='mb-1'>
                                                            <span className='text-muted fw-bold text-uppercase' style={{ fontSize: '0.7em' }}>Unidad:</span>
                                                            <span style={{ textDecoration: porcentajeDescuento > 0 ? 'line-through' : 'none', color: porcentajeDescuento > 0 ? '#6c757d' : '#2E0205', fontSize: porcentajeDescuento > 0 ? '0.85em' : '1em', fontWeight: porcentajeDescuento > 0 ? 'normal' : 'bold', marginLeft: '4px' }}>
                                                                ${formatCurrency(precioU)}
                                                            </span>
                                                        </div>
                                                        {porcentajeDescuento > 0 && (
                                                            <div className='d-flex align-items-center'>
                                                                <span className='fw-bold' style={{ color: '#dc3545', fontSize: '1.05em' }}>
                                                                    ${formatCurrency(priceWithDiscount)}
                                                                </span>
                                                                <span className="ms-1 badge" style={{ backgroundColor: '#f8d7da', color: '#842029', fontSize: '0.65em', border: '1px solid #f5c2c7', fontWeight: '600' }}>
                                                                    -{porcentajeDescuento}%
                                                                </span>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        );
                                    })()}
                                </Col>
                                <Col xs={4} md={2} className="d-flex justify-content-end align-items-center">
                                    <Button
                                        variant='danger'
                                        className='d-flex justify-content-center align-items-center'
                                        onClick={() => handleRemoveProduct(product)}
                                    >
                                        <Trash3Fill />
                                    </Button>
                                </Col>
                                <div className="d-flex justify-content-between align-items-center mt-2 w-100">
                                    <Button
                                        variant="danger"
                                        className="flex-grow-0"
                                        size="sm"
                                        style={{ width: '20%' }}
                                        onClick={() => handleDecreaseQuantity(product.idProducto, product.selectedColor, product.selectedSize)}
                                    >
                                        -
                                    </Button>
                                    <span
                                        className="mx-2 text-center border"
                                        style={{
                                            flexGrow: 1,
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {product.quantity || 1}
                                    </span>
                                    <Button
                                        variant="success"
                                        className="flex-grow-0"
                                        size="sm"
                                        style={{ width: '20%' }}
                                        onClick={() => handleIncreaseQuantity(product.idProducto, product.selectedColor, product.selectedSize)}
                                        disabled={product.quantity >= product.stock}
                                    >
                                        +
                                    </Button>
                                </div>
                            </Row>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
                <div className="d-flex justify-content-between mt-3">
                    <strong className='fw-bold color-primary'>Subtotal:</strong>
                    <strong className='fw-bold text-muted'>${formatCurrency(totalPrecio)}</strong>
                </div>

                {porcentajeDescuento !== null && porcentajeDescuento > 0 ? (
                    <div className="d-flex justify-content-between mt-3">
                        <strong className='fw-bold color-primary'>Descuento aplicado:</strong>
                        <strong className='fw-bold text-danger'>-{porcentajeDescuento}%</strong>
                    </div>
                ) : (
                    configDescuento?.tipoConfig !== 'desable' && porcentajeDescuento === null && (
                        <div className="d-flex justify-content-between mt-3">
                            <strong className='fw-bold color-primary'>Precio aplicado:</strong>
                            <strong className='fw-bold text-danger'>Mayorista</strong>
                        </div>
                    )

                )}

                {porcentajeDescuento !== null && porcentajeDescuento > 0 && (
                    <div className="d-flex justify-content-between mt-3">
                        <strong className='fw-bold color-primary'>Total con descuento:</strong>
                        <strong className='fw-bold text-muted'>${formatCurrency(totalConDescuento)}</strong>
                    </div>
                )}

                <div className="d-flex justify-content-between mt-3">
                    <strong className='fw-bold color-primary'>Envío:</strong>
                    <strong style={{ color: envioCosto > 0 ? 'inherit' : 'green' }}>
                        {isEnvioDisabled
                            ? '+ Costo de Envío'
                            : (envioCosto > 0 ? `$ ${formatCurrency(envioCosto)}` : '¡GRATIS!')}
                    </strong>
                </div>

                <div className="d-flex justify-content-between mt-3">
                    <strong className='fw-bold color-primary'>Total a pagar:</strong>
                    <strong className='fw-bold text-dark'>${formatCurrency(totalConDescuento + envioCosto)}</strong>
                </div>

                <div className="mt-4 mb-3 p-3 rounded">
                    <Form noValidate validated={validated}>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold color-primary">Tu Nombre <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="Ej. Juan Pérez"
                                value={nombreCliente}
                                onChange={(e) => setNombreCliente(e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid">
                                Por favor, ingresa tu nombre.
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label className="fw-bold color-primary">Tu Teléfono (WhatsApp) <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="Ej. 3001234567"
                                value={telefonoCliente}
                                onChange={(e) => setTelefonoCliente(e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid">
                                Por favor, ingresa tu número de teléfono.
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form>
                </div>

                {carrito.length === 0 ? (
                    <Button
                        variant='success'
                        className="mt-3 w-100 d-flex justify-content-center align-items-center"
                        disabled
                    >
                        No hay productos en el carrito
                    </Button>
                ) : (
                    <Button
                        variant='success'
                        className="mt-3 w-100 d-flex justify-content-center align-items-center"
                        onClick={handleSendPedido}
                        disabled={isSending}
                    >
                        {isSending ? 'Enviando...' : <><Whatsapp className='me-2' size={18} /> Enviar pedido</>}
                    </Button>
                )}

                <Button
                    variant='danger'
                    className='mt-2 w-100 d-flex justify-content-center align-items-center'
                    onClick={handleClearCarrito}
                >
                    <Trash3Fill /> Vaciar carrito
                </Button>
                <div className='mt-3'>
                    <p className='small text-muted text-center'>
                        Al enviar el pedido te redirigirá a WhatsApp con uno de nuestros asesores donde podrás terminar el proceso.
                    </p>
                </div>

            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default CarUni;
